import moment from 'moment'
import { DATE_FORMAT, sendAllMessageStrings } from '../../../constants'

/** 配信予定日時。復元できなかった予約でも一覧から取り消せるよう行自体は残す */
export function formatScheduledDateTime(value: string | null): string {
  if (!value) return sendAllMessageStrings.reservations.scheduledDateTimeUnknown
  return moment(value).format(`${DATE_FORMAT} HH:mm`)
}
